<template>
  <div class="list-head row">
    <div class="col-12 col-md-9">
      <ul class="nav tabs" v-if="tabActive">
        <li
          v-if="!$isCallCenter"
          role="presentation"
          :class="{ active: tabActive === 'draft' }"
          @click="setTab('draft')"
          class="tab mx-3"
        >
          <h3>{{ $t("feature.article.tabs.draft") }}</h3>
          <p>{{ statusCount.draft }} รายการ</p>
        </li>
        <li
          v-if="!$isCallCenter"
          role="presentation"
          :class="{ active: tabActive === 'toBeApproved' }"
          @click="setTab('toBeApproved')"
          class="tab mx-3"
        >
          <h3>{{ $t("feature.article.tabs.toBeApproved") }}</h3>
          <p>{{ statusCount.toBeApproved }} รายการ</p>
        </li>
        <li
          v-if="!$isCallCenter"
          role="presentation"
          :class="{ active: tabActive === 'toBePublished' }"
          @click="setTab('toBePublished')"
          class="tab mx-3"
        >
          <h3>{{ $t("feature.article.tabs.toBePublished") }}</h3>
          <p>{{ statusCount.toBePublished }} รายการ</p>
        </li>
        <li
          role="presentation"
          :class="{ active: tabActive === 'published' }"
          @click="setTab('published')"
          class="tab mx-3"
        >
          <h3>{{ $t("feature.article.tabs.published") }}</h3>
          <p>{{ statusCount.published }} รายการ</p>
        </li>
        <li
          v-if="!$isCallCenter"
          role="presentation"
          :class="{ active: tabActive === 'all' }"
          @click="setTab('all')"
          class="tab mx-3"
        >
          <h3>{{ $t("feature.article.tabs.all") }}</h3>
          <p>{{ statusCount.all }} รายการ</p>
        </li>
      </ul>
    </div>
    <div class="col-12 col-md-3 text-right">
      <div class="input-group my-3 px-4">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1"
            ><i class="fas fa-search"></i
          ></span>
        </div>
        <input
          type="text"
          class="form-control"
          :placeholder="$t('feature.article.search.article_title')"
          v-model.lazy="currentSearchText"
          @keyup.enter="enterSearch"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list-head",
  props: ["tabActive", "statusCount", "searchText"],
  data() {
    return {
      currentSearchText: this.searchText
    };
  },
  methods: {
    setTab(tab) {
      this.$emit("tab", tab);
    },
    enterSearch() {
      this.$emit("search", this.currentSearchText);
    }
  }
};
</script>

<style lang="scss" scoped>
.list-head {
  .tabs {
    height: 72px;
    padding: 16px 24px 0 16px;

    .tab {
      border: none;
      color: #8c8786;
      letter-spacing: -0.1px;
      font-weight: 500;
      text-align: left;
      min-width: 110px;

      &.active {
        border-bottom: 2px solid $orange;

        h3 {
          font-weight: bold;
          color: $black;
        }
        p {
          font-weight: bold;
          color: $orange;
        }
      }
      h3 {
        font-size: 16px;
        line-height: 1.38;
        color: inherit;
        margin: 0;
      }
      p {
        font-size: 11px;
        line-height: 1.64;
        color: inherit;
      }
    }
  }
  .input-group {
    &-text {
      background: $white;
      border-right: none;
      border-radius: 25px 0 0 25px;
      line-height: 40px;
    }
    .form-control {
      font-size: 14px;
      font-weight: 500;
      color: #616161;
      line-height: 1.87;
      border: 1px solid #ced4da;
      border-left: none;
      border-radius: 0 25px 25px 0;
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .list-head {
    .tabs {
      .tab {
        min-width: 70px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/list/ListHead.vue